import { Component, ReactNode } from 'react';
import { Amplitude, Events } from '@iwoca/frontend-tracking-library';
import { t } from '@lingui/macro';
import { ErrorCard } from 'components/ErrorCard/ErrorCard';
import { Link } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './ErrorBoundary.module.css';

interface Props {
  children: ReactNode;
  locale: string;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch() {
    Amplitude.track(
      Events.introducerPortal.introducerPortalEventCreator({
        event: AMPLITUDE_EVENTS.typescriptErrorCaught,
        locale: this.props.locale,
      }),
    );
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorCard
          className={styles.errorCard}
          code={500}
          message={t`Sorry, an internal error occurred. Please try again later.`}
          action={<Link to={PATH_NAMES.home()}>{t`Return to dashboard`}</Link>}
        />
      );
    }

    return this.props.children;
  }
}
